import { render, staticRenderFns } from "./roomsNum.vue?vue&type=template&id=69f39d86&scoped=true"
import script from "./roomsNum.vue?vue&type=script&lang=js"
export * from "./roomsNum.vue?vue&type=script&lang=js"
import style0 from "./roomsNum.vue?vue&type=style&index=0&id=69f39d86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f39d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f39d86')) {
      api.createRecord('69f39d86', component.options)
    } else {
      api.reload('69f39d86', component.options)
    }
    module.hot.accept("./roomsNum.vue?vue&type=template&id=69f39d86&scoped=true", function () {
      api.rerender('69f39d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/roomsNum.vue"
export default component.exports